export default {
    namespaced: true,
    state: {
        excludedSites: [],
    },
    getters: {
        EXCLUDED_SITES: state => {
            return state.excludedSites;
        },
    },
    mutations: {
        EXCLUDED_SITES: (state, payload) => {
            return state.excludedSites = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/excluded-sites',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.excludedSites = responseData.excludedSites
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/excluded-sites',
                parameter: state.excludedSites,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.excludedSites = responseData.excludedSites
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                }
            });
        },
    }
}